import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

import { map } from 'rxjs/operators';
import { EmployeeModel } from '../models/employee.model';

const base_url = environment.base_url;

@Injectable({
  providedIn: 'root'
})
export class EmpleadoService {

  constructor( private http: HttpClient ) { }


get token(): string {
  return localStorage.getItem('token') || '';
}

get headers() {
 return {
   headers: {
    'x-token': this.token
   }
};
}


  cargarEmpleados() {


  const url = `${ base_url }/employees`;
  return this.http.get( url, this.headers)
                  .pipe(
                    map( (resp: { ok: boolean, employees: EmployeeModel[] }) => resp.employees )
                  );

  }

  obtenerEmpleadoPorId( id: string) {
  const url = `${ base_url }/employees/${ id }`;
  return this.http.get( url, this.headers)
                  .pipe(
                    map( (resp: { ok: boolean, employee: EmployeeModel }) => resp.employee )
                  );

  }


  crearEmpleado( empleado: { nombre: string, subarea: string } ) {
  const url = `${ base_url }/employees`;
  return this.http.post( url, empleado, this.headers);
  }
  actualizarEmpleado( empleado: EmployeeModel ) {
  const url = `${ base_url }/employees/${ empleado._id }`;
  return this.http.put( url, empleado, this.headers);
  }
  borrarEmpleado( _id: string ) {
  const url = `${ base_url }/employees/${ _id }`;
  return this.http.delete( url, this.headers);
  }

}
